import { createApi } from '@reduxjs/toolkit/query/react';
import { apiAppointmentNoteTypes } from 'tsx/constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

export const typePrefix = 'client-note-types';

interface NoteType {
  id: number;
  name: string;
}

export const noteTypesApi = createApi({
  reducerPath: 'noteTypesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiAppointmentNoteTypes }),
  tagTypes: ['noteTypes', 'noteType'],
  endpoints: (builder) => ({
    getNoteTypes: builder.query<NoteType[], Request>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: [{ type: 'noteTypes', id: 'LIST' }],
      transformResponse: (payload) => unwrap<NoteType[]>(payload),
    }),
    getNoteType: builder.query<NoteType, Request>({
      query: (params) => {
        const { id, ...restParams } = params ?? {};
        return { url: `/${id}`, method: 'GET', ...restParams };
      },
      providesTags: [{ type: 'noteType', id: 'LIST' }],
      transformResponse: (payload) => unwrap<NoteType>(payload),
    }),
  }),
});

export const { useGetNoteTypesQuery, useGetNoteTypeQuery } = noteTypesApi;
